import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import useMediaQuery from 'utils/hooks/useMediaQuery';
import IntroductionDisclaimer from '../../IntroductionDisclaimer';
import StepGuideNumbers from '../../StepGuideNumbers';
import StepInfoContainer from '../../StepInfo/container';
import Step1Form from './components/Step1Form';
import { STEP_1_INFO } from './constants';
import "./styles/Step1.scss";
import { useStateMachine } from 'little-state-machine';
import { updateAction } from 'scenes/ProjectMultiStepForm/store';
import LinkRequiredInformation from '../../StepGuideNumbers/components/LinkRequiredInformation';

const Step1 = () => {
  const { state, actions } = useStateMachine({ updateAction });
  const isMobile = useMediaQuery("(max-width: 1199px)");
  const progressStepValue = 33;
  const currentSteps = [0, 1];

  useEffect(() => {
    actions.updateAction({
      ...state,
      showDownloadFormatsModal: true
    });
  }, [])

  return (
    <main className="step0--main">
      <StepInfoContainer
        subtitle={STEP_1_INFO.subtitle}
        additionalInfo={STEP_1_INFO.additionalInfo}
        description={STEP_1_INFO.description}
      />
      {isMobile && (
        <StepGuideNumbers
          currentStep={currentSteps}
          progressStepValue={progressStepValue}
          isMobile={isMobile}
        />
      )}
      <section className="step0--main__wizard-form">
        {!isMobile && <StepGuideNumbers currentStep={currentSteps} />}
        <div className="main__wizard-container border bg-light col-12 col-lg-8 p-4 px-lg-5">
          <progress max={100} value={progressStepValue} className="w-100" />
          <div className='d-flex justify-content-end align-items-center py-4'>
            {isMobile && <LinkRequiredInformation />}
          </div>
          <h5 className="step0--main__form-title font-weight-bold">
            <FormattedMessage
              id="ProjectStepForm.step1.title"
              defaultMessage="Información general del proyecto"
            />
          </h5>
          <hr />
          <p className="step0--main__form-description font-weight-bold">
            <FormattedMessage
              id="ProjectStepForm.step1.description"
              description="Step 1 form description"
              defaultMessage="A continuación, debes diligenciar todos los datos del proyecto"
            />
          </p>
          <Step1Form />
        </div>
      </section>

      <IntroductionDisclaimer />
    </main>
  );
}

export default Step1;